import * as React from "react";
import { SVGProps } from "react";

const Pearl = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 512 512"
    {...props}
  >
    <style>{".st0{fill:#8a67ac}"}</style>
    <path d="M256 211c-24.8 0-45 20.2-45 45 0 8.3 6.7 15 15 15s15-6.7 15-15 6.7-15 15-15 15-6.7 15-15-6.7-15-15-15z" />
    <path d="M475.8 282.6c22.3-16.7 36.2-43 36.2-71.6 0-38.6-25.2-72.6-61.5-85-5-53.8-50-96-104.5-96-5.1 0-10.3.4-15.7 1.4C310.5 11.3 283.9 0 256 0s-54.5 11.3-74.3 31.4C176.2 30.5 171 30 166 30c-55 0-100.5 42.9-105.5 96C24.8 138.4 0 172.4 0 211c0 28.8 13.8 55.2 35.8 71.8C12 296.6 0 312.8 0 331v1.3C1 431.5 115.4 512 256 512s255-80.5 256-179.8v-1.3c0-18.2-12.2-34.5-36.2-48.3zM482 211c0 25.1-16.4 47.7-40.3 56.4-22.7-8-50.2-14.5-80.9-19-.8-11.1-3.4-21.7-7.4-31.6l84.4-63.3c25.9 7.3 44.2 30.8 44.2 57.5zM330.5 61.8c5.6-1.2 10.7-1.8 15.5-1.8 39 0 71 30.2 74.6 68.8l-82.5 61.9c-10.8-13.5-24.8-24.3-40.9-31.2l33.3-97.7zM331 256c0 41.4-33.6 75-75 75s-75-33.6-75-75 33.6-75 75-75 75 33.6 75 75zM256 30c17.5 0 34.3 6.3 47.7 17.6l-35.6 104.1c-4-.5-8-.7-12.1-.7s-8.1.2-12.1.7L208.3 47.6C221.7 36.3 238.5 30 256 30zm-90 30c4.8 0 9.8.6 15.5 1.8l33.3 97.6c-16.1 6.9-30.2 17.7-41 31.3l-83.4-62C94.2 90.8 127.3 60 166 60zM30 211c0-26.8 17.9-50.3 43.3-57.6l85.3 63.4c-4 9.9-6.5 20.5-7.3 31.6-31 4.6-58.6 11.1-81.4 19.2C46.2 259.1 30 236.4 30 211zm226 271c-96.5 0-179.1-41.5-211.4-98 56.8 28.4 147 37 211.4 37s154.6-8.7 211.4-37c-33.1 57.9-116.9 98-211.4 98zm0-91c-140.2 0-226-36.8-226-60 0-6.5 8.9-17.5 33.7-28.8 22.4-10.1 53.8-18.4 89.7-23.9 1.1 5.2 2.6 10.2 4.5 15.1-19.9 12.9-32.5 26.9-33.1 27.6-5.5 6.2-5 15.6 1.2 21.2s15.7 5 21.2-1.2c.1-.1 9.9-10.9 25.4-21.3C191.8 344.8 222 361 256 361s64.2-16.2 83.4-41.3c15.4 10.4 25.3 21.2 25.4 21.3 5.5 6.2 15 6.7 21.2 1.2 6.2-5.5 6.7-15 1.2-21.2-.6-.7-13.2-14.6-33.1-27.6 1.9-4.9 3.4-9.9 4.5-15.1 84 12.8 123.4 37.8 123.4 52.6 0 23-84.6 60.1-226 60.1z" />
    <path
      d="M482 211c0 25.1-16.4 47.7-40.3 56.4-22.7-8-50.2-14.5-80.9-19-.8-11.1-3.4-21.7-7.4-31.6l84.4-63.3c25.9 7.3 44.2 30.8 44.2 57.5zM330.5 61.8c5.6-1.2 10.7-1.8 15.5-1.8 39 0 71 30.2 74.6 68.8l-82.5 61.9c-10.8-13.5-24.8-24.3-40.9-31.2l33.3-97.7z"
      className="st0"
    />
    <circle cx={256} cy={256} r={75} />
    <path
      d="M256 30c17.5 0 34.3 6.3 47.7 17.6l-35.6 104.1c-4-.5-8-.7-12.1-.7s-8.1.2-12.1.7L208.3 47.6C221.7 36.3 238.5 30 256 30zm-90 30c4.8 0 9.8.6 15.5 1.8l33.3 97.6c-16.1 6.9-30.2 17.7-41 31.3l-83.4-62C94.2 90.8 127.3 60 166 60zM30 211c0-26.8 17.9-50.3 43.3-57.6l85.3 63.4c-4 9.9-6.5 20.5-7.3 31.6-31 4.6-58.6 11.1-81.4 19.2C46.2 259.1 30 236.4 30 211z"
      className="st0"
    />
    <path
      fill="#8c69af"
      d="M256 482c-96.5 0-179.1-41.5-211.4-98 56.8 28.4 147 37 211.4 37s154.6-8.7 211.4-37c-33.1 57.9-116.9 98-211.4 98z"
    />
    <path
      fill="#b49ac9"
      d="M256 391c-140.2 0-226-36.8-226-60 0-6.5 8.9-17.5 33.7-28.8 22.4-10.1 53.8-18.4 89.7-23.9 1.1 5.2 2.6 10.2 4.5 15.1-19.9 12.9-32.5 26.9-33.1 27.6-5.5 6.2-5 15.6 1.2 21.2s15.7 5 21.2-1.2c.1-.1 9.9-10.9 25.4-21.3C191.8 344.8 222 361 256 361s64.2-16.2 83.4-41.3c15.4 10.4 25.3 21.2 25.4 21.3 5.5 6.2 15 6.7 21.2 1.2 6.2-5.5 6.7-15 1.2-21.2-.6-.7-13.2-14.6-33.1-27.6 1.9-4.9 3.4-9.9 4.5-15.1 84 12.8 123.4 37.8 123.4 52.6 0 23-84.6 60.1-226 60.1z"
    />
    <circle cx={255.9} cy={256.1} r={75} fill="#e5e5e5" />
    <linearGradient
      id="SVGID_1_"
      x1={200.47}
      x2={273.47}
      y1={276.91}
      y2={276.91}
      gradientTransform="matrix(1 0 0 -1 0 514)"
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.006} stopColor="#f2f2f2" />
      <stop offset={1} stopColor="#fff" />
    </linearGradient>
    <circle cx={237} cy={237.1} r={36.5} fill="url(#SVGID_1_)" />
  </svg>
);

export default Pearl;
